<template>
  <section>
    <div class="container">
      <div class="columns is-multiline module-1-4-boxes__content">
        <div class="column is-8-desktop is-12-tablet is-12-mobile">
          <Skeletor class="module-1-4-boxes__content--left" width="100%" height="534" />
        </div>
        <div class="column is-4-desktop is-12-tablet is-12-mobile">
          <div class="module-1-4-boxes__content--right">
            <Skeletor class="module-1-4-boxes__right-box" width="100%" height="130" />
            <Skeletor class="module-1-4-boxes__right-box" width="100%" height="130" />
            <Skeletor class="module-1-4-boxes__right-box" width="100%" height="130" />
            <Skeletor class="module-1-4-boxes__right-box" width="100%" height="130" />
          </div>
        </div>
        <div class="module-boxes">
          <div class="container">
            <div class="columns block-box">
              <div class="column is-4-desktop is-6-tablet is-6-mobile">
                <Skeletor class="mb-box" width="100%" height="545" />
              </div>
              <div class="column is-4-desktop is-6-tablet is-6-mobile">
                <Skeletor class="mb-box" width="100%" height="545" />
              </div>
              <div class="column is-4-desktop is-6-tablet is-6-mobile">
                <Skeletor class="mb-box" width="100%" height="545" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.module-1-4-boxes {
  &__right-box {
    display: flex;
    align-items: flex-start;
    margin: 2px 0;
    border: none;
    position: relative;
    @media (max-width: $desktop) {
      width: 49%;
      margin: 5px 0;
    }
  }
}
.module-boxes {
  width: 100%;
}
</style>
